<!-- Liste des destinataires des notifications -->
<list-view [liste]="listviewDestinataire"></list-view>